import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Grid,
  Button,
  useMediaQuery,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Slide,
  useScrollTrigger
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import axios from "axios";

const NAV_LINKS = [
  { label: "Home", path: "/user-home" },
  { label: "Albums", path: "/user-albums" },
  { label: "Frames", path: "/user-frames" },
  { label: "Photo Selection", path: "/user-photo-selection" },
  { label: "Prices", path: "/user-prices" },
  { label: "Contact", path: "/user-contact" },
  { label: "About", path: "/user-about" }
];

function HideOnScroll(props) {
  const { children } = props;
  const trigger = useScrollTrigger();

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

const UserHome = () => {
  const [studio, setStudio] = useState(null);
  const [studioImages, setStudioImages] = useState([]);
  const [currentImg, setCurrentImg] = useState(0);
  const [services, setServices] = useState([]);
  const [footers, setFooters] = useState({});
  const [flipped, setFlipped] = useState([]);
  const clientMongoId = localStorage.getItem("clientMongoId");
  const isMobile = useMediaQuery("(max-width:600px)");
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    async function fetchStudio() {
      const res = await axios.get(
        `https://studio-lc.onrender.com/api/clients/${clientMongoId}`
      );
      setStudio(res.data);
    }
    fetchStudio();
  }, [clientMongoId]);

  useEffect(() => {
    async function fetchImages() {
      if (!clientMongoId) return;
      try {
        const res = await axios.get(
          `https://studio-lc.onrender.com/api/clients/${clientMongoId}/studio-images`
        );
        setStudioImages(
          res.data.studioImages && res.data.studioImages.length > 0
            ? res.data.studioImages
            : [
                "https://images.unsplash.com/photo-1519125323398-675f0ddb6308",
                "https://images.unsplash.com/photo-1506744038136-46273834b3fb",
                "https://images.unsplash.com/photo-1465101046530-73398c7f28ca",
                "https://images.unsplash.com/photo-1517841905240-472988babdf9",
                "https://images.unsplash.com/photo-1465101178521-c1a4c8a0a8b7"
              ]
        );
      } catch (err) {
        setStudioImages([
          "https://images.unsplash.com/photo-1519125323398-675f0ddb6308",
          "https://images.unsplash.com/photo-1506744038136-46273834b3fb",
          "https://images.unsplash.com/photo-1465101046530-73398c7f28ca",
          "https://images.unsplash.com/photo-1517841905240-472988babdf9",
          "https://images.unsplash.com/photo-1465101178521-c1a4c8a0a8b7"
        ]);
      }
    }
    fetchImages();
  }, [clientMongoId]);

  useEffect(() => {
    async function fetchServices() {
      if (!clientMongoId) return;
      try {
        const res = await axios.get(
          `https://studio-lc.onrender.com/api/clients/${clientMongoId}/services`
        );
        setServices(res.data.services || []);
      } catch (err) {
        setServices([]);
      }
    }
    fetchServices();
  }, [clientMongoId]);

  useEffect(() => {
    async function fetchFooters() {
      if (!clientMongoId) return;
      try {
        const res = await axios.get(
          `https://studio-lc.onrender.com/api/clients/${clientMongoId}/footers`
        );
        setFooters(res.data.footers || {});
      } catch (err) {
        setFooters({});
      }
    }
    fetchFooters();
  }, [clientMongoId]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImg((prev) => (prev + 1) % studioImages.length);
    }, 2000);
    return () => clearInterval(interval);
  }, [studioImages]);

  useEffect(() => {
    setFlipped(Array(services.length).fill(false));
  }, [services]);

  if (!studio) return <Typography>Loading...</Typography>;

  return (
    <Box
      sx={{
        bgcolor: "#fff",
        minHeight: "100vh",
        width: "100%",
        overflowX: "hidden"
      }}
    >
      {/* Responsive AppBar with hide-on-scroll and mobile drawer */}
      <HideOnScroll>
        <AppBar
          position="fixed"
          sx={{
            bgcolor: "#fff",
            boxShadow: 3,
            height: isMobile ? 56 : 80,
            zIndex: 1201
          }}
        >
          <Toolbar
            sx={{
              minHeight: isMobile ? 56 : 80,
              px: isMobile ? 1 : 3,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: isMobile ? "space-between" : "center"
            }}
          >
            <Typography
              variant={isMobile ? "h5" : "h4"}
              sx={{
                fontFamily: "Josefin Sans",
                fontWeight: 900,
                color: "#8b5e3c",
                letterSpacing: 2,
                mr: isMobile ? 0 : 4,
                flexShrink: 0
              }}
            >
              {studio.studio}
            </Typography>
            {/* Desktop Nav Links Centered */}
            {!isMobile && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                
                  alignItems: "center",
                  gap: 4,
                  flexGrow: 1
                }}
              >
                {NAV_LINKS.map((link) => (
                  <Button
                    key={link.label}
                    href={link.path}
                    sx={{
                      color: "#8b5e3c",
                      fontWeight: 700,
                      fontSize: 22,
                      fontFamily: "Josefin Sans",
                      textTransform: "none",
                      letterSpacing: 1.5
                    }}
                  >
                    {link.label}
                  </Button>
                ))}
              </Box>
            )}
            {isMobile && (
              <IconButton
                edge="end"
                color="inherit"
                aria-label="menu"
                onClick={() => setDrawerOpen(true)}
                sx={{ ml: "auto" }}
              >
                <MenuIcon sx={{ color: "#8b5e3c", fontSize: 36 }} />
              </IconButton>
            )}
          </Toolbar>
        </AppBar>
      </HideOnScroll>
      {/* Drawer for mobile */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      >
        <Box sx={{ width: 220, mt: 6 }}>
          <List>
            {NAV_LINKS.map((link) => (
              <ListItem
                button
                key={link.label}
                component="a"
                href={link.path}
                onClick={() => setDrawerOpen(false)}
              >
                <ListItemText
                  primary={link.label}
                  primaryTypographyProps={{
                    fontSize: 20,
                    fontWeight: 600,
                    fontFamily: "Josefin Sans",
                    color: "#8b5e3c"
                  }}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
      {/* Add a spacer for the fixed AppBar */}
      <Box sx={{ height: isMobile ? 56 : 80 }} />
      {/* Studio Image Slider */}
      <Box sx={{ p: 2, pt: isMobile ? 10 : 15 }}>
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mt:isMobile ? -8 : -13 }}>
          <Box
            sx={{
              width: "100%",
              maxWidth: 1650,
              height: { xs: 220, sm: 320, md: 540 },
              overflow: "hidden",
              borderRadius: 2,
              boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
              mb: 2,
              position: "relative",
              background: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <img
              src={studioImages[currentImg]}
              alt={`studio-${currentImg}`}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: 12,
                transition: "opacity 0.5s"
              }}
            />
          </Box>
          {/* Studio Name and Description */}
          <Typography
            variant="h4"
            sx={{
              mb: 2,
              mt: 2,
              fontWeight: 700,
                fontFamily: "Josefin Sans",
              color: "#8b5e3c"
            }}
          >
            {studio.studio}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              mb: 2,
              maxWidth: 1500,
              textAlign: "center",
              fontSize: isMobile ? 16 : 23,
              fontFamily: "Jost",
            }}
          >
            {studio.studioDescription || studio.descriptionText}
          </Typography>
        </Box>
        {/* Services Section as Flip Cards */}
        <Box sx={{ mt: 6, mb: 2 }}>
          <Typography
            variant="h4"
            sx={{
              display: "inline-block",
              textAlign: "center",
              fontWeight: 700,
              mb: 4,
              width: "95%",
              color: "#8b5e3c",
              letterSpacing: 2,
              background: "linear-gradient(90deg, #f9efcdff 60%, #fdd79dff 100%)",
              px: 6,
              py: 1.5,
              borderRadius: 6,
              boxShadow: "0 2px 12px 0 rgba(194, 155, 99, 0.10)",
              mx: "auto",
              fontFamily: "Josefin Sans",
              fontSize : isMobile ? 28 : 38
            }}
          >
            Services
          </Typography>
          <Grid container spacing={10} columns={12} justifyContent="center">
            {services.map((service, idx) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                key={service.title + idx}
                sx={{
                  display: "flex",
                  justifyContent: "center"
                }}
              >
                <Box
                  sx={{
                    perspective: "1200px",
                    width: isMobile ? 320 : 340,
                    height: isMobile ? 350 : 370,
                    bgcolor: "transparent",
                    mb: isMobile ? 3 : 2,
                    animation: "fadeIn 1s",
                    "@keyframes fadeIn": {
                      from: { opacity: 0, transform: "translateY(40px)" },
                      to: { opacity: 1, transform: "none" }
                    }
                  }}
                >
                  <Box
                    sx={{
                      position: "relative",
                      width: "100%",
                      height: "100%",
                      transition: "transform 0.6s",
                      transformStyle: "preserve-3d",
                      transform: flipped[idx] ? "rotateY(180deg)" : "none"
                    }}
                  >
                    {/* Front Side */}
                    <Box
                      sx={{
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        backfaceVisibility: "hidden",
                        background: "linear-gradient(135deg, #fff, #fff8e1 60%, #fbe9e7 100%)",
                        borderRadius: 6,
                        border: "1.5px solid #f5e1c1",
                        boxShadow: "0 8px 32px rgba(194, 155, 99, 0.13)",
                        p: 2,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        transition: "box-shadow 0.3s, transform 0.3s",
                        "&:hover": {
                          boxShadow: "0 16px 40px rgba(194, 155, 99, 0.22)",
                          transform: "scale(1.045)"
                        }
                      }}
                    >
                      <img
                        src={service.img}
                        alt={service.title}
                        style={{
                          width: "108%",
                          height: isMobile ? 150 : 170,
                          objectFit: "cover",
                          borderTopLeftRadius: 16,
                          borderTopRightRadius: 16,
                          borderBottomLeftRadius: 0,
                          borderBottomRightRadius: 0,
                          marginTop: -15,
                          marginBottom: 20,
                          display: "block",
                          boxShadow: "0 4px 16px rgba(194, 155, 99, 0.18)"
                        }}
                      />
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 1000,
                          fontFamily: "Josefin Sans",
                          color: "#a67c52",
                          mb: 1,
                          textAlign: "center",
                        }}
                      >
                        {service.title}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "black",
                          textAlign: "center",
                          mb: 2,
                          fontFamily: "Josefin Sans",
                          wordBreak: "break-word",
                          overflowWrap: "break-word",
                          width: "100%",
                          maxHeight: 80,
                          overflowY: "auto"
                        }}
                      >
                        {service.desc}
                      </Typography>
                      <Box sx={{ flexGrow: 1 }} /> {/* This pushes the button to the bottom */}
                      <Box sx={{ textAlign: "center", mb: 1 }}>
                        <button
                          style={{
                            background: "#a67c52",
                            color: "#fff",
                            border: "none",
                            borderRadius: 20,
                            padding: "8px 28px",
                            fontWeight: 700,
                            cursor: "pointer",
                            fontSize: 16,
                            fontFamily: "Jost",
                            boxShadow: "0 2px 8px rgba(166,124,82,0.12)"
                          }}
                          onClick={() =>
                            setFlipped((prev) =>
                              prev.map((f, i) => (i === idx ? !f : f))
                            )
                          }
                        >
                          More Info
                        </button>
                      </Box>
                    </Box>
                    {/* Back Side */}
                    <Box
                      sx={{
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        backfaceVisibility: "hidden",
                        background: "linear-gradient(135deg, #fff, #fff8e1 60%, #fbe9e7 100%)",
                        borderRadius: 14,
                        border: "1.5px solid #f5e1c1",
                        boxShadow: "0 8px 32px rgba(194, 155, 99, 0.13)",
                        p: 2,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        transform: "rotateY(180deg)",
                        transition: "box-shadow 0.3s, transform 0.3s"
                      }}
                    >
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 1000,
                          color: "#a67c52",
                          mb: 2,
                          textAlign: "center",
                           fontFamily: "Josefin Sans",
                        }}
                      >
                        {service.title}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#5d4037",
                          textAlign: "center",
                          whiteSpace: "pre-line",
                          mb: 2,
                          fontFamily: "jost"
                        }}
                      >
                        {service.details}
                      </Typography>
                      <Box sx={{ textAlign: "center" }}>
                        <button
                          style={{
                            background: "#a67c52",
                            color: "#fff",
                            border: "none",
                            borderRadius: 20,
                            padding: "8px 28px",
                            fontWeight: 700,
                            cursor: "pointer",
                            fontSize: 16,
                            fontFamily: "'Montserrat', sans-serif",
                            boxShadow: "0 2px 8px rgba(166,124,82,0.12)"
                          }}
                          onClick={() =>
                            setFlipped((prev) =>
                              prev.map((f, i) => (i === idx ? !f : f))
                            )
                          }
                        >
                          Back
                        </button>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
      {/* Footer Section */}
      <Box
        sx={{
          bgcolor: "#a67c52",
          color: "#fff",
           fontFamily: "Josefin Sans",
          mt: 4,
          pt: 4,
          pb: 2
        }}
      >
        <Grid container spacing={2} sx={{ maxWidth: 1300, mx: "auto" }}>
          {/* Left Column */}
          <Grid item xs={12} md={3} sx={{ml: { xs: 3 }, mt: { xs: 6,  }}}>
            <Typography variant="h5" sx={{ fontWeight: 700,  fontFamily: "Josefin Sans",  }}>
              {footers.studio}
            </Typography>
            <Typography variant="body1" sx={{  fontFamily: "Jost",fontSize:17}}>{footers.tag}</Typography>
            <Typography variant="body2" sx={{  fontFamily: "Jost",fontSize:17}}>{footers.handle}</Typography>
          </Grid>
          {/* Center Column */}
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              ml: { xs: 0, md: 12 }
            }}
          >
            <Typography
              variant="body1"
              sx={{
                textAlign: "center",
                fontSize: 18,
                mb: 2,
                fontFamily: "Jost",
              }}
            >
              {footers.text}
            </Typography>
          </Grid>
          {/* Right Column */}
          <Grid item xs={12} md={3}>
            <Box sx={{ display: "flex", gap: 2, mb: 2,ml: { xs: 3, md: 15 } ,mt: { xs: 6, md: 5 } }}>
              {/* WhatsApp */}
              <a href="https://wa.me/919123456789" target="_blank" rel="noopener noreferrer">
                <Box sx={{ bgcolor: "#25D366", borderRadius: "50%", p: 1 }}>
                  <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" style={{ width: 28, height: 28 }} />
                </Box>
              </a>
              {/* Instagram */}
              <a href="https://instagram.com/" target="_blank" rel="noopener noreferrer">
                <Box sx={{ bgcolor: "#fff", borderRadius: "50%", p: 1 }}>
                  <img src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png" alt="Instagram" style={{ width: 28, height: 28 }} />
                </Box>
              </a>
              {/* Gmail */}
              <a href="mailto:studioartmdu@gmail.com" target="_blank" rel="noopener noreferrer">
                <Box sx={{ bgcolor: "#fff", borderRadius: "50%", p: 1 }}>
                  <img src="https://upload.wikimedia.org/wikipedia/commons/4/4e/Gmail_Icon.png" alt="Gmail" style={{ width: 28, height: 28 }} />
                </Box>
              </a>
              {/* YouTube */}
              <a href="https://youtube.com/" target="_blank" rel="noopener noreferrer">
                <Box sx={{ bgcolor: "#fff", borderRadius: "50%", p: 1 }}>
                  <img src="https://upload.wikimedia.org/wikipedia/commons/4/42/YouTube_icon_%282013-2017%29.png" alt="YouTube" style={{ width: 28, height: 28 }} />
                </Box>
              </a>
            </Box>
          </Grid>
          {/* Bottom Row */}
          <Grid
            item
            xs={12}
            sx={{
              borderTop: "1px solid #fff2",
              mt: 0,
              ml: {xs:5, md:50},
              pt: 2,
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
            <Typography variant="body2" sx={{ fontSize: 16,  fontFamily: "Josefin Sans", }}>
              {footers.copyright}
            </Typography>
            <Typography variant="body2" sx={{ fontSize: 16,  fontFamily: "Josefin Sans", }}>
              {footers.made}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default UserHome;